/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：53__part-1
 */

import packageInfo from "../../../package.json"
import * as /* [auto-meaningful-name] */Module_60 from /* 60 */"../../../unrestored/shared/1571/2636/60"

var _ = 20
var v = 40
export const RELEASE_VERSION = packageInfo.version
var y = []
var E = 320
var O = .8
var /* [auto-meaningful-name] */http__www$w3$org_2000_svg = "http://www.w3.org/2000/svg"
var C = 3
export { _ }
export { v }
export { RELEASE_VERSION as b }
export { y }
export { E }
export { O }
export { http__www$w3$org_2000_svg as w }
export { C }
